import { Translation } from "../../hooks/useTranslations";
import { Car } from "../cars/types";
import { DefaultTask } from "../defaultTasks/types";
import { User } from "../users/types";

export type CarTaskState = "not-required" | "to-do" | "done";

export type CarTask = {
  id: string;
  car: Car;
  taskName: string;
  defaultTask?: DefaultTask;
  driver?: User;
  state?: CarTaskState;
  lastModifiedBy?: User;
  lastModifiedAt?: string;
  createdAt: string;
  workflowId?: string;
  workflowState?: string;
  workflowCreatedAt?: string;
};

export type CarTaskNoCarDependency = Omit<CarTask, "car"> & {
  car: {
    id: string;
    vehicleIdentificationNumber: string;
    currentPlateNumber?: string;
    lastPlateNumber?: string;
  };
};

export type InsertCarTask = {
  taskName?: string;
  defaultTaskId?: string;
};

export type UpdateCarTask = {
  taskName: string;
};

export const getTaskStateColor = (state?: CarTaskState): "blue" | "red" | "green" => {
  switch (state) {
    case "to-do":
      return "red";
    case "done":
      return "green";
    default:
      return "blue";
  }
};

export const getTaskStateText = (t: Translation, state?: CarTaskState): string => {
  switch (state) {
    case "to-do":
      return t.common.todo;
    case "done":
      return t.common.done;
    default:
      return t.common.notRequired;
  }
};
